import { Page, BlockStack } from '@shopify/polaris';

const SettingsPage = ({ children, title, description, ...pageProps }) => {
  return (
    <Page title={title} subtitle={description} {...pageProps}>
      <BlockStack gap="400">
        {children}
      </BlockStack>
    </Page>
  );
}

export default SettingsPage;
